import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { ZiggyVue } from '@/../../vendor/tightenco/ziggy';

createInertiaApp({
	title: (title) => `${title}`,
	resolve: name => require(`@/pages/${name}`),
	setup({ el, App, props, plugin }) {
		return createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(ZiggyVue)
			.mount(el);
	},
	progress: {
		color: '#4B5563',
	},
});

$(document).on('click', '[data-dt-btn="edit"]', (event) => {
	event.preventDefault();
	router.get($(event.currentTarget).attr('href'));
});

